export const SAVED_ARTISTS_HEIGHT = "25%"

export const DEFAULT_HOME_DATA = {
    following: [
        "0cDoc4aM13X3qAfLJha3rOGQaEb2",
        "9IpZ2aBayIbqINj7afZSo8gr2Bb2",
        "JUXUJr7POiMJBHHYHffJtm3ca4H3",
        "LR4TPprzYqOYuCmUcmMVJkRprWg1"
    ],
    likedTracks: [
        "4TJ01Zzutnmtgms6kGps",
        "EOZ79XMy3eAHp9QMD7em",
        "QiHBJJJmmn4MhF3FpbLk",
        "XFVxfbduweL74GlHlXOp",
        "aZ5d8a5OlQr107or8XZj",
        "gUvEINYAjYWndPC4bqXn",
        "j7SkofzZXBRh3Rm01ijx"
    ],
    homeTracks: [
        "4TJ01Zzutnmtgms6kGps",
        "EOZ79XMy3eAHp9QMD7em",
        "QiHBJJJmmn4MhF3FpbLk",
        "XFVxfbduweL74GlHlXOp",
        "aZ5d8a5OlQr107or8XZj",
        "gUvEINYAjYWndPC4bqXn",
        "j7SkofzZXBRh3Rm01ijx"
    ]
}